const CkoPaySkeleton = () => <div className="animate-pulse space-y-6 rounded border p-4" data-sentry-component="CkoPaySkeleton" data-sentry-source-file="CkoPaySkeleton.jsx">
    {/* Card button header */}
    <div className="flex items-center justify-between">
      <div className="flex items-center gap-3">
        <div className="h-6 w-10 rounded bg-gray-200"></div>
        <div className="h-4 w-20 rounded bg-gray-200"></div>
      </div>
    </div>

    {/* Form fields */}
    <div className="space-y-4">
      {/* Cardholder Name */}
      <div>
        <div className="mb-2 h-4 w-32 rounded bg-gray-200"></div>
        <div className="h-10 rounded bg-gray-200"></div>
      </div>

      {/* Card Number */}
      <div>
        <div className="mb-2 h-4 w-24 rounded bg-gray-200"></div>
        <div className="mb-2 h-10 rounded bg-gray-200"></div>
      </div>

      {/* Expiry Date */}
      <div className="flex gap-4">
        <div className="flex-1">
          <div className="mb-2 h-4 w-20 rounded bg-gray-200"></div>
          <div className="h-10 rounded bg-gray-200"></div>
        </div>
        <div className="flex-1">
          <div className="mb-2 h-4 w-24 rounded bg-gray-200"></div>
          <div className="h-10 rounded bg-gray-200"></div>
        </div>
      </div>
    </div>
  </div>;
export default CkoPaySkeleton;